import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77438fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "upButton",
  class: "up-button"
}

import { useWindowScroll } from '@vueuse/core';
import { computed } from 'vue';
import { useChatStore } from '@/store/modules/chat';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseUpButton',
  setup(__props) {

const { x, y } = useWindowScroll();

const showBtn = computed(() => {
  return y.value > window.innerHeight;
});
const scrollToTop = () => {
  y.value = 0;
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (showBtn.value && !_unref(useChatStore)().miniMessenger.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "up-button__btn center",
          onClick: scrollToTop
        }, [
          _createVNode(_component_base_icon, {
            color: "#ffffff",
            name: "arrow_upward"
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})